import { render, staticRenderFns } from "./ChangeLogTable.vue?vue&type=template&id=71cd024a"
import script from "./ChangeLogTable.vue?vue&type=script&lang=js"
export * from "./ChangeLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports